// api.js

import axiosInstance from "../axiosInstance";

export const oauthClientService = {
  create: async (data) => {
    try {
      let response = await axiosInstance.post("/oauth-client", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetch: async (limit, skip, selectedUser) => {
    try {
      let response = await axiosInstance.get(
        `/oauth-client?$limit=${limit || 15}&$skip=${skip || 0}&${
          selectedUser ? `user=${selectedUser}&` : ""
        }`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  edit: async (id, data) => {
    try {
      let response = await axiosInstance.patch(`/oauth-client/${id}`, {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  delete: async (id) => {
    try {
      let response = await axiosInstance.delete(`/oauth-client/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  authorize: async (data) => {
    try {
      let response = await axiosInstance.post("/oauth-authorize", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  generateToken: async (data) => {
    try {
      let response = await axiosInstance.post("/oauth-token", {
        ...data,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchToken: async (limit, skip, clientId) => {
    try {
      let query = `$limit=${limit || 15}&$skip=${skip || 0}`;
      if (clientId) {
        query += `&client_id=${clientId}`;
      }

      const response = await axiosInstance.get(`/token?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
